require('./myTopic.less')
require('../../app/app');

var i18n = require('i18n');
var util = require('../../app/util');
var pageConfig = window.pageConfig || {};
var pagination = require('../../app/pagination');
var topicList = require('../../app/topicList.html');
var wrapper = require('../../app/main.html');
pageConfig.adStr = pageConfig.admin ? i18n('admin') : pageConfig.plateAd ? i18n('plate.admin') : '';


var App = {
  init: function() {
  	if (pageConfig.error) {
  		util.show(pageConfig.error, 'error');
  		return;
  	}
  	
  	pageConfig.login = true;
		$('body').append(wrapper(pageConfig));
		
		var reg = new RegExp(pageConfig.projectName + '\/(.+)\/topic');
		var id = parseInt(location.pathname.match(reg)[1], 10);
		var uid = util.getUid();
		


		$('.list-title').text((id === uid ? i18n('pub.topic') : i18n('his.topic')) + ':')
    var userAgent = window.navigator.userAgent || '';
    if (userAgent.match(/[bB]ot\//)  || userAgent.match('[sS]pider')) {
      return
    }
		pagination(`${pageConfig.projectName}/topic/myTopicList?uid=${id}`, topicList, null, null, {
      showDelete: true
    });
  }
}

// Entry
;(function() {
  App.init();
})();







// WEBPACK FOOTER //
// ./src/pages/myTopic/myTopic.js